import { useEffect } from 'react';

/**
 * Block browser/OS back navigation while `active` is true. Mirrors the native
 * `PopScope(canPop: false)` used on status takeovers and the pickup/delivery
 * progress screens: the driver can only leave via an explicit in-screen action
 * (Cancel / complete), never the hardware/browser back button.
 */
export function useBlockBack(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const onPop = () => window.history.pushState(null, '', window.location.href);
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [active]);
}
